import React, { useState } from 'react';

import { Tooltip, useMediaQuery, useTheme } from '@material-ui/core';

import { UiButton } from '../../../../ui/ui-button';

import { employeeNameFromSimpleContact } from '../../../../employees/utils/employee-name';
import { formatPhoneNumber } from '../../../../util/formatters';

type InputProps = {
  messageDetail: AnnouncementDeliverabilityDetail;
  tooltip?: string;
  retrySendMessage?: (handleRetrySendMessage: AnnouncementDeliverabilityDetail) => Promise<boolean>;
};

export const MessageDeliveryStatusRow = (props: InputProps) => {
  const { messageDetail, tooltip, retrySendMessage } = props;

  const [messageResent, setMessageResent] = useState<boolean>(false);

  const theme = useTheme();
  const isOnMobile = useMediaQuery(theme.breakpoints.down('xs'));

  const handleRetrySendMessage = async () => {
    if (!messageResent && retrySendMessage) {
      const sentMessage = await retrySendMessage(messageDetail);
      setMessageResent(sentMessage);
    }
  };

  return (
    <div
      className={`${
        isOnMobile ? 'u-height-80px' : 'u-height-40px'
      } u-display-flex u-justifyContent-spaceBetween u-alignItems-center`}
    >
      <div className="u-width-40">
        <Tooltip title={tooltip || ''}>
          <span>
            {employeeNameFromSimpleContact({
              nickname: messageDetail.nickname,
              firstName: messageDetail.firstName,
              lastName: messageDetail.lastName,
            })}
          </span>
        </Tooltip>
      </div>
      <div className="u-width-30">
        {messageDetail.messageType === 'text'
          ? formatPhoneNumber(messageDetail.phoneNumber)
          : messageDetail.email}
      </div>
      <div className="u-width-30 u-textAlign-right">
        {retrySendMessage ? (
          <UiButton
            disabled={messageResent}
            size="sm"
            variant="contained"
            onClick={handleRetrySendMessage}
            className="u-color-action"
          >
            Retry
          </UiButton>
        ) : null}
      </div>
    </div>
  );
};
